import { render, staticRenderFns } from "./ticker.vue?vue&type=template&id=60cba120"
import script from "./ticker.vue?vue&type=script&lang=js"
export * from "./ticker.vue?vue&type=script&lang=js"
import style0 from "./ticker.vue?vue&type=style&index=0&id=60cba120&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports